// extracted by mini-css-extract-plugin
export default {"format":"DesignFormat_format__wEmZH","name":"DesignFormat_name__LgmwL","icon":"DesignFormat_icon__Cr7Ae"};